import React from "react";
import { FiArrowUpRight, FiArrowRight } from "react-icons/fi";

function ProjectCards({
  id, number, category, title, description, highlights, technologies,
  imgPath, imageAlt, repoLink, featured,
  previewLabel, previewCaption,
}) {
  return (
    <article
      className={`project-entry project-entry--${id}${featured ? " project-entry--featured" : ""}`}
      aria-labelledby={`project-${id}-title`}
    >
      <a
        className="project-preview"
        href={repoLink}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`View ${title} on GitHub (opens in a new tab)`}
      >
        <span className="project-preview-number" aria-hidden="true">
          {String(number).padStart(2, "0")}
        </span>
        {previewLabel ? (
          <div className="project-brand">
            <img src={imgPath} alt={imageAlt} loading="lazy" />
            <span>{previewLabel}</span>
            <small>{previewCaption}</small>
          </div>
        ) : (
          <img src={imgPath} alt={imageAlt} loading={featured ? "eager" : "lazy"} />
        )}
        <span className="project-preview-arrow" aria-hidden="true"><FiArrowUpRight /></span>
      </a>
      <div className="project-details">
        <p className="project-category">{category}</p>
        <h2 id={`project-${id}-title`}>{title}</h2>
        <p className="project-description">{description}</p>
        <ul className="project-highlights" aria-label="Key features">
          {highlights.map((highlight) => (
            <li key={highlight}><FiArrowRight aria-hidden="true" />{highlight}</li>
          ))}
        </ul>
        <ul className="project-technologies" aria-label="Technology stack">
          {technologies.map((technology) => <li key={technology}>{technology}</li>)}
        </ul>
        <a className="project-visit" href={repoLink} target="_blank" rel="noopener noreferrer">
          View on GitHub<FiArrowUpRight aria-hidden="true" />
          <span className="visually-hidden"> for {title} (opens in a new tab)</span>
        </a>
      </div>
    </article>
  );
}
export default ProjectCards;
